// extracted by mini-css-extract-plugin
export default {"withSpacing":"PgbBOL"};